import { Normal6 } from 'components/Typography';
import dynamic from 'next/dynamic';

const MigrationPanel = dynamic(() => import('../MigrationPanel'), {
  ssr: false,
});
interface IsupportedTokens {
  title: string;
}

export function MigrationPageContainer({ title }: IsupportedTokens) {
  return (
    <div className='relative flex flex-col gap-10 p-4 px-6 pt-8 max-lg:pt-0 2xl:max-w-screen-2xl'>
      <Normal6 className='font-bold text-white'>{title}</Normal6>
      <MigrationPanel />
    </div>
  );
}
